import { setTopBottomSafeArea } from "core/javascriptChannels";

export const handleSafeAreaChange = (value: boolean) => {
  setTopBottomSafeArea && setTopBottomSafeArea(value);
};
